import { useShellRootContext } from 'src/contexts/ShellRoot';
import { serviceId } from 'src/constants/ServiceIdentifier';
import { useMfeOptions } from 'src/contexts/MfeOptionsContext';

export const usePublishRumEvent = () => {
  const {
    options: { initializationMethod }
  } = useMfeOptions();
  const {
    interfaces: { v1 }
  } = useShellRootContext();

  const publishRumEvent = async (error) => {
    const attributes = {
      ['workflow.name']: error?.errorCode,
      ['payload']: error?.message,
      ['initialization.method']: initializationMethod
    };

    const span = v1.monitoring.startSpan(serviceId, attributes);
    await span?.end?.();
  };

  return { publishRumEvent };
};
